import styled from 'styled-components'

export const Heading = styled.h1<{ noMargin?: boolean }>`
  font-weight: bold;
  font-size: 24px;
  ${(props) => props.noMargin && 'margin: 0;'}
`
